export default __webpack_public_path__ + "static/media/lamp.17f7e9c9.svg";